import { parse, isBefore, isValid } from 'date-fns';

export function beforeDate(dateToCompare: Date) {
  return (value: string) => {
    const date = parse(value, 'dd/MM/yyyy', new Date());

    return isValid(date) && isBefore(date, dateToCompare);
  };
}
